// Decide para qual passo do fluxo de conta o usuário deve ir. Cada página chama
// nextStep ao carregar e redireciona se o passo não for o dela.
export type Step = "login" | "check-email" | "set-password" | "mfa-enroll" | "mfa-challenge" | "app" | "admin";

export interface AuthState {
  signedIn: boolean;
  emailConfirmed: boolean;
  currentLevel: "aal1" | "aal2" | null;
  nextLevel: "aal1" | "aal2" | null;
  isAdmin: boolean;
  /**
   * Convidado (operador) que ainda não definiu a senha. Vem do user_metadata
   * (invitation_id sem password_set): é só dica de tela, nunca autorização.
   */
  needsPassword: boolean;
  /** Conta criada por convite (user_metadata.invitation_id). Só para escolher textos. */
  invited: boolean;
}

export function nextStep(s: AuthState): Step {
  if (!s.signedIn) return "login";
  if (!s.emailConfirmed) return "check-email";
  // Convite: a senha vem antes do autenticador. Quem já tem fator passou deste passo.
  if (s.needsPassword && s.nextLevel === "aal1") return "set-password";
  if (s.nextLevel === "aal1") return "mfa-enroll";
  if (s.currentLevel === "aal1" && s.nextLevel === "aal2") return "mfa-challenge";
  if (s.currentLevel === "aal2") return s.isAdmin ? "admin" : "app";
  // Estado inesperado (níveis nulos com sessão): recomeça pelo login.
  return "login";
}

/** A página aceita o passo? Uma página pode aceitar mais de um (app.html aceita o admin). */
export function stepAllowed(step: Step, own: Step | readonly Step[]): boolean {
  return typeof own === "string" ? step === own : own.includes(step);
}
